<div class="bg-white rounded-lg shadow-lg p-4">
    <p class="font-bold">{{form.restaurantName | titlecase}}</p>
    <p>Address: {{form.restaurantAddress | titlecase}}</p>
    <p>Submitted: {{form.created.seconds * 1000 | date}}</p>
    <p>Contact name: {{form.contactName | titlecase}}</p>
    <p>Contact phone number: {{form.contactPhone}}</p>
    <p>Contact email: {{form.contactEmail}}</p>
    <p>Status: {{form.status | titlecase}}</p>
</div>